module.exports = __webpack_public_path__ + "img/saleuse.f84d8890.jpg";